'use strict';

var AbstractFormView = require('components/common/views/abstract_form_view');
var Requests = require('utils/requests');

var PasswordResetView = AbstractFormView.extend({
    template: require('components/account/templates/password_reset'),

    controller: undefined,

    events: {
        'click button.js-reset': 'resetClicked',
        'click a#js-terms': 'termsClicked',
        'click a#js-gdpr': 'gdprClicked',
        'click a#js-imprint': 'imprintClicked',
    },

    initialize: function (options) {
        this.controller = options.controller;

        AbstractFormView.prototype.initialize.apply(this, [
            {
                inputFields: {
                    'js-email': {
                        method: 'email',
                    },
                },
                errors: options.errors,
                formData: options.formData,
            },
        ]);
    },

    termsClicked: function (e) {
        e.preventDefault();
        this.controller.showTermsDialog();
    },

    gdprClicked: function (e) {
        e.preventDefault();
        this.controller.showGdprDialog();
    },

    imprintClicked: function (e) {
        e.preventDefault();
        this.controller.showImprint();
    },

    resetClicked: function (e) {
        e.preventDefault();
        if (this.allFieldsValid()) {
            this.controller.passwordReset(Backbone.Syphon.serialize(this));
        }
    },

    onAttach: function () {
        var subdomain = Requests.getSubdomain(window.location.host) || 'samson';
        $('.account-pages').css('background-image', 'url(../img/backgrounds/' + subdomain + '.jpg)');
    },
});

module.exports = PasswordResetView;
